/* lp-aging-faq.js — Aging LP accordion FAQ */
(function () {
  function initAgingFaq(section) {
    var items = section.querySelectorAll('.lp-aging-faq__item');

    items.forEach(function (item) {
      var btn = item.querySelector('.lp-aging-faq__question');
      var answer = item.querySelector('.lp-aging-faq__answer');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all other items in this section
        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            other.classList.remove('is-open');
            other.querySelector('.lp-aging-faq__answer').style.maxHeight = '0';
          }
        });

        // Toggle clicked item
        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = '0';
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  // Init on page load
  document.querySelectorAll('.lp-aging-faq-section').forEach(initAgingFaq);

  // Shopify Theme Editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector('.lp-aging-faq-section')) {
      initAgingFaq(section.querySelector('.lp-aging-faq-section'));
    }
  });
})();
